import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';

import { AvatarStyled, CallIconAvatar } from '../styles';

export const COPIES = strings.ai.generators.roleplay;

export const RoleplayCallWaiting = () => {
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      gridGap={24}
      height="100%"
      justifyContent="center"
      width="100%"
    >
      <AvatarStyled>
        <CallIconAvatar />
      </AvatarStyled>
      <Typography align="center" variant="h6">
        {COPIES.success.phoneShouldRing}
      </Typography>
      <Typography align="center" color="textSecondary" variant="body2">
        {COPIES.success.answerCall}
      </Typography>
    </Box>
  );
};
